<template>
  <div class="w-75 d-flex justify-content-between">
    <button
      v-if="FacebookLogin"
      type="button"
      :class="GoogleLogin?'w-48':'w-100'"
      class="btn btn-social btn-lg btn-fb d-flex justify-content-center fs-1 fw-600"
      @click="fbLogin"
    >
      <img
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGFyaWEtbGFiZWw9IkZhY2Vib29rIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+PHJlY3Qgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIHJ4PSIxNSUiIGZpbGw9IiNmZmYiLz48cGF0aCBmaWxsPSIjM2I1OTk4IiBkPSJNMzMwIDUxMlYzMjJoNjRsOS03NGgtNzN2LTQ3YzAtMjIgNi0zNiAzNy0zNmgzOVY5OWMtNy0xLTMwLTMtNTctMy01NyAwLTk1IDM0LTk1IDk4djU0aC02NHY3NGg2NHYxOTB6Ii8+PC9zdmc+"
        alt="facebookIcon"
      />
      <p>{{ $t('message.facebook') }}</p>
    </button>
    <button
      v-if="GoogleLogin"
      type="button"
      :class="FacebookLogin?'w-48':'w-100'"
      class="btn btn-social btn-lg btn-gplus d-flex justify-content-center fs-1 fw-600"
      @click="gglLogin"
    >
      <img
        alt="googleIcon"
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGFyaWEtbGFiZWw9Ikdvb2dsZSIgdmlld0JveD0iMCAwIDUxMiA1MTIiPjxyZWN0IHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiByeD0iMTUlIiBmaWxsPSIjZmZmIi8+PHBhdGggZmlsbD0iIzQyODVmNCIgZD0iTTM4NiA0MDBjNDUtNDIgNjUtMTEyIDUzLTE3OUgyNjB2NzRoMTAyYy00IDI0LTE4IDQ0LTM4IDU3eiIvPjxwYXRoIGZpbGw9IiMzNGE4NTMiIGQ9Ik05MCAzNDFhMTkyIDE5MiAwIDAwMjk2IDU5bC02Mi00OGMtNTMgMzUtMTQxIDIyLTE3MS02MHoiLz48cGF0aCBmaWxsPSIjZmJiYzAyIiBkPSJNMTUzIDI5MmMtOC0yNS04LTQ4IDAtNzNsLTYzLTQ5Yy0yMyA0Ni0zMCAxMTEgMCAxNzF6Ii8+PHBhdGggZmlsbD0iI2VhNDMzNSIgZD0iTTE1MyAyMTljMjItNjkgMTE2LTEwOSAxNzktNTBsNTUtNTRjLTc4LTc1LTIzMC03Mi0yOTcgNTV6Ii8+PC9zdmc+"
      />
      <p class="pr-4">{{ $t('message.google') }}</p>
    </button>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  methods: {
    fbLogin() {
      this.$parent.facebookLogin();
    },
    gglLogin() {
      this.$parent.googleLogin();
    }
  },
  computed: {
    ...mapGetters(["viewConfig"]),
    FacebookLogin() {
      return this.viewConfig.FacebookLogin;
    },
    GoogleLogin() {
      return this.viewConfig.GoogleLogin;
    }
  }
};
</script>
